// extracted by mini-css-extract-plugin
module.exports = {"viewer":"VideoViewer_viewer__3pOi2","viewerInline":"VideoViewer_viewerInline__2W1D7","emptyMessage":"VideoViewer_emptyMessage__pMqxz"};